import { render, staticRenderFns } from "./LabelDocumentsBlock.vue?vue&type=template&id=be19308a&scoped=true"
import script from "./LabelDocumentsBlock.vue?vue&type=script&lang=js"
export * from "./LabelDocumentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be19308a",
  null
  
)

export default component.exports